<template>
  <div class="club-management-page container-fluid">
    <!-- Mensaje para usuarios sin club vinculado -->
    <div v-if="!usuarioActual.club && !esAdmin" class="alert alert-warning text-center p-4 rounded mt-4">
      <h4 class="mb-2"><font-awesome-icon icon="exclamation-circle" class="me-2 text-warning" /> Sin acceso</h4>
      <p>No tienes un club vinculado. Por favor, solicita acceso a un club para continuar.</p>
    </div>

    <!-- Funcionalidades para administradores -->
    <div v-if="esAdmin" class="admin-section mt-4">
      <h2 class="text-center mb-4"><font-awesome-icon icon="user-cog" class="me-2" /> Administración de Clubes</h2>
      <div class="club-list-container">
        <ListarClubes />
      </div>
    </div>

    <!-- Vista para usuarios con club asociado -->
    <div v-else-if="usuarioActual.club" class="user-section mt-4">
      <h2 class="text-center mb-4"><font-awesome-icon icon="building" class="me-2" /> Mi Club</h2>
      <div class="club-details-container">
        <VerClub :club_id="club_id_actual" />
      </div>
    </div>
  </div>
</template>

<script>
import ListarClubes from '@/components/Club/listar-clubes.vue';
import VerClub from '@/components/Club/ver-club.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    ListarClubes,
    VerClub,
  },
  data() {
    return {
      club_id_actual: null,
    };
  },
  computed: {
    ...mapGetters(['getUsuarioActual']),
    usuarioActual() {
      return this.getUsuarioActual;
    },
    esAdmin() {
      return this.usuarioActual.rol === 'Administrador';
    },
  },
  watch: {
    usuarioActual: {
      immediate: true,
      handler(nuevoUsuario) {
        if (nuevoUsuario.club) {
          this.club_id_actual = Number(nuevoUsuario.club.id);
        }
      },
    },
  },
};
</script>

<style scoped>
.club-management-page {
  padding: 20px 20px 0; /* Elimina margen superior extra */
  background-color: #f9fafc;
  min-height: 100vh;
}

.alert-warning {
  background-color: #fff8e5;
  border: 1px solid #ffebbb;
}

.admin-section,
.user-section {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

h2 {
  font-size: 1.8rem;
  font-weight: bold;
  color: #333;
}

.club-list-container {
  max-width: 1200px;
  margin: 0 auto;
}

.club-details-container {
  max-width: 800px;
  margin: 0 auto;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
</style>

<style>
/* Estilos globales para asegurar que no haya margen superior */
body {
  margin: 0;
  padding: 0;
}
</style>
